<template>
  <div>
    <TagSelector
      :multiple="multiple"
      :items="list"
      :value="value"
      @input="$emit('input', $event)"
      itemText="title"
      itemValue="id"
    />
    <v-btn
      small
      outlined
      color="primary"
      @click="dialog = true;"
      class= "qb-project-search-btn"
    >
      Find a new QB Project
    </v-btn>
    <v-dialog
      v-model="dialog"
      width="600"
    >
      <v-card>
        <v-btn class="dialog-close" icon @click="cancel">
          <v-icon>$close</v-icon>
        </v-btn>
        <v-card-title>Search for a Quickbooks Project</v-card-title>
        <v-card-text>
          <div class="qb-project-search-holder">
            <TextField
              placeholder="Try a project code or partner name"
              v-model="search"
              class= "qb-project-dialog__search-input"
            ></TextField>
            <v-btn
              color="primary"
              @click="searchQbProjects()"
              class= "qb-project-dialog-btn"
            >
              Search
            </v-btn>
          </div>
          <v-data-table
            class="qb-project__search-results elevation-0 data-table"
            :headers="headers"
            hide-default-footer
            :items="searchResults"
            item-key="Id"
            v-if="searchResults.length"
          >
            <template v-slot:body="{ items }">
              <tbody v-for="item in items" :key="item.Id">
                <tr class="data-table__row">

                  <td>{{ item.qb_title }}</td>
                  <td >{{ item.code }}</td>
                  <td >{{ item.qb_id }}</td>
                  <td>
                    <v-btn
                      small
                      outlined
                      color="primary"
                      @click="selectResult(item)"
                    >
                      {{ item.id ? "Select" : "Import and Select" }}
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
          <Spinner v-else-if="searching" />
          <div v-else-if="notSearchingYet" />
          <div v-else>No results</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TextField from '../TextField.vue';
export default {
  components: { TextField },
  props: {
    value: [String, Number, Array],
    multiple: Boolean,
  },
  data() {
    return {
      list: [],
      dialog: false,
      search: "",
      notSearchingYet: true,
      searching: false,
      searchResults: [],
      headers: [
        {
          text: 'Name',
          align: 'start',
          value: 'qb_title',
        },
        {
          text: 'Code',
          align: 'start',
          value: 'code',
        },
        {
          text: 'QB Id',
          align: 'start',
          value: 'qb_id',
        },
      ],
    };
  },
  created() {
    this.setQbProjects();
  },
  methods: {
    async setQbProjects() {
      const { data } = await this.$api.QbProject.lite();
      this.list = [
        { title: "N/A", id: null },
        ...data,
      ];
    },
    async searchQbProjects() {
      if(!this.search) return;
      this.searchResults = [];
      this.notSearchingYet = false;
      this.searching = true;
      const { data } = await this.$api.QbProject.search({search: this.search});
      this.searching = false;
      this.searchResults = data;
    },
    async selectResult(item) {
      if(!item.id){
        const { data } = await this.$api.QbProject.create({
          qb_id: item.qb_id,
          title: item.qb_title
        });
        await this.setQbProjects();
        this.dialog = false;
        this.$emit("input", data.id);

      } else {
        await this.setQbProjects();
        this.dialog =  false;
        this.$emit("input", item.id);
      }
    },
    cancel() {
      this.dialog = false;
    }
  },
};
</script>

<style lang="scss" scoped>

.dialog-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.qb-project-search-holder {
  display: flex;
  flex-wrap: wrap;
}
.qb-project-search-btn,
.qb-project-dialog-btn {
  margin-top: .75em;
}
.qb-project-dialog__search-input {
  margin-right: 1em;
}
.spinner.relative {
  min-height: 100px;
}
</style>
